import { ErrorHandler, Injectable, inject, NgZone } from '@angular/core';
import { LoggerService } from './logger.service';
import { AnalyticsService } from './analytics.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private logger = inject(LoggerService);
  private analytics = inject(AnalyticsService);
  private ngZone = inject(NgZone);

  handleError(error: unknown): void {
    this.ngZone.run(() => {
      const err = error instanceof Error ? error : new Error(String(error));

      if (this.isChunkLoadError(err)) {
        this.logger.warn('Lazy-loaded chunk failed to load — reloading page', err.message);
        window.location.reload();
        return;
      }

      const error_slug = err.message.replace(/\s+/g, ' ').trim().slice(0, 120);
      this.analytics.logEvent('app_error', {
        error_name: err.name,
        error_slug,
      });

      this.logger.error('Unhandled error', {
        message: err.message,
        stack: err.stack,
        name: err.name,
      });
    });
  }

  private isChunkLoadError(error: Error): boolean {
    return (
      error.name === 'ChunkLoadError' ||
      error.message.includes('Loading chunk') ||
      error.message.includes('Failed to fetch dynamically imported module')
    );
  }
}
